/**
 * 법적 표기 + 사업자 정보 + 약관 링크.
 * (legal) / 랜딩 / (dashboard) 모두에 마운트.
 */

import Link from 'next/link';

export function Footer() {
  return (
    <footer className="border-t border-neutral-200 bg-white">
      <div className="max-w-6xl mx-auto px-4 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-neutral-500">
        <div>
          © 2026 Auto-Playlist. All rights reserved.
        </div>
        <nav className="flex flex-wrap gap-x-4 gap-y-1">
          <Link href="/terms" className="hover:text-neutral-900">이용약관</Link>
          <Link href="/privacy" className="hover:text-neutral-900">개인정보처리방침</Link>
          <Link href="/refund" className="hover:text-neutral-900">환불정책</Link>
          <Link href="/business-info" className="hover:text-neutral-900">사업자정보</Link>
          <a href="mailto:contact@demaf.kr" className="hover:text-neutral-900">문의</a>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
